<template>
  <div class="main-page">
    <section class="page-section mb-3">
      <div class="container-fluid">
        <div class="grid justify-content-between">
          <div class="col-12 md:col-6 lg:col-5">
            <div class="">
              <div class="flex align-items-center">
                <div>
                  <Avatar
                    size="large"
                    class="primary"
                    icon="pi pi-question-circle"
                  />
                </div>
                <div class="ml-2 mr-3">
                  <div class="text-2xl text-primary font-bold">
                    Help and Support
                  </div>
                  <div class="text-sm text-500">FAQS</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="page-section">
      <hr />
      <div class="container-fluid">
        <div class="grid">
          <div class="col comp-grid">
            <div class="card nice-shadow-18">
              <Accordion :activeIndex="[0]">
                <AccordionTab header="What is Caps?">
                  <p>
                    Centralize Application Processing System (CAPS) is a
                    centralized system that has all universities on board to
                    make it easy and affordable for students to apply to schools
                    of their choice..Students are able to apply three(3) schools
                    using the same pin purchased.
                  </p>
                </AccordionTab>
                <AccordionTab header="What are the entry requirements?">
                  <p>
                    Admission requirement for entry is wassce results,ssce
                    results with minimum grade c6. Also applicants with
                    certificate acquired in other qualifications can apply.
                  </p>
                </AccordionTab>

                <AccordionTab
                  header="How do I get the template for data import?"
                >
                  <p>
                    There is no template for import of data. All import actions
                    use the same template as the files exported from the Applicants page.
                    To clarify, only excel files downloaded from the platform
                    can be imported back to the platform.
                  </p>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { PageMixin } from "../../mixins/page.js";
export default {
  name: "help",
  components: {},
  mixins: [PageMixin],
  props: {
    pageName: {
      type: String,
      default: "help",
    },
    routeName: {
      type: String,
      default: "help",
    },
    pagePath: {
      type: String,
      default: "help",
    },
  },
  data() {
    return {
      item: {
        default: {},
      },
    };
  },
  computed: {
    pageTitle: {
      get: function () {
        return "Help and Support";
      },
    },
  },
  methods: {},
  watch: {
    $route(to, from) {
      //only fetch data when navigated to this page
      if (to.name == this.routeName) {
        //this.load();
      }
    },
  },
  mounted() {},
};
</script>
<style scoped></style>
